import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';
import FormsBuilder from '~/services/filter-form-service/FilterFormBuilder';
import { METADATA } from '~/constants/conversationModels';
import { GetFilters } from '~/constants/getters';

export class FilterFormService {
  constructor({ store, arcaneApiGateway }) {
    this.store = store;
    this.arcaneApiGateway = arcaneApiGateway;
    this.formBuilder = new FormsBuilder();
    this.form = {};
  }

  applyTypeToFilters(filters, type) {
    let filtersDataWithType = filters;
    if (type === 'document') {
      filtersDataWithType = filtersDataWithType.map((filter) => ({
        ...filter,
        type: 'multiselectLabels',
      }));
    } else {
      filtersDataWithType = filtersDataWithType.map((filter) => ({
        ...filter,
        type: 'picklist',
      }));
    }

    return filtersDataWithType;
  }

  /**
   * Data to populate the filter dropdowns based on the available data in Opensearch.
   */
  async getFilterForm(type = 'document') {
    try {
      // Check if formFilters exist in store for this type
      const formFilters = this.store?.getters?.[`formFiltersStore/${GetFilters}`] || {};
      const selectedFiltersRaw = formFilters[type] || {};

      // Filter out keys where value is an empty array
      const selectedFilters = Object.fromEntries(
        Object.entries(selectedFiltersRaw).filter(
          ([, value]) => !(Array.isArray(value) && value.length === 0),
        ),
      );

      const { data } = await this.arcaneApiGateway.post(apiGatewayEndpoints.filters.conversationFilters, {
        ...(Object.keys(selectedFilters).length > 0 && { selectedFilters }),
        type,
      });

      const filtersDataWithType = this.applyTypeToFilters(data.filters, type);
      const newForm = this.formBuilder.buildForm(filtersDataWithType);

      // If form exists and we have selectedFilters, merge with existing form
      if (this.form[type] && Object.keys(selectedFilters).length > 0) {
        this.form[type] = this.form[type].map((formFilter) => {
          const newFilter = newForm.find((filterConfig) => filterConfig.id === formFilter.id);
          return { ...formFilter, ...newFilter };
        });
      } else {
        // Build form from scratch (initial load or no selectedFilters)
        this.form[type] = newForm;
      }

      return this.form[type];
    } catch (error) {
      console.log('error in getting filters', error);
      return [];
    }
  }

  async getProductAndCountryFormFilters(type = 'document') {
    try {
      const { data } = await this.arcaneApiGateway.post(apiGatewayEndpoints.filters.conversationFilters, {
        type,
      });

      const dataFilters = (
        data?.filters?.filter((item) => item.id === METADATA.product_name || item.id === METADATA.country) || []
      ).map((filter) => ({
        ...filter,
        type: 'multiselectCheckboxes',
      }));

      this.form[type] = this.formBuilder.buildForm(dataFilters);
      return this.form[type];
    } catch (error) {
      console.log('error in getting filters', error);
      return [];
    }
  }

  async getUpdatedProductAndCountryFilters(type = 'document', selectedFilters = {}) {
    const { data } = await this.arcaneApiGateway.post(apiGatewayEndpoints.filters.conversationFilters, {
      selectedFilters,
      type,
    });

    const filtersDataWithType = (
      data?.filters?.filter((item) => item.id === METADATA.product_name || item.id === METADATA.country) || []
    ).map((filter) => ({
      ...filter,
      type: 'multiselectCheckboxes',
    }));

    const newForm = this.formBuilder.buildForm(filtersDataWithType);

    this.form[type] =
        this.form[type].map((formFilter) => {
          const newFilter = newForm.find((filterConfig) => filterConfig.id === formFilter.id);
          formFilter.type = 'multiselectCheckboxes';
          return { ...formFilter, ...newFilter };
        })
        .filter((item) => item.id === METADATA.product_name || item.id === METADATA.country) || [];

    return this.form[type];
  }
}
